import AppConfig from "util/AppConfig";
export const isFieldFavorite = ({ contexts, field }) => !!contexts.favoriteFields.find((f) => f === field);
const ToggleFavoriteField = async ({ contexts, field }) => contexts.toggleFavoriteField(field);
ToggleFavoriteField.isHidden = (isAdding, props) => {
  var _a;
  return !AppConfig.isFeatureEnabled("message_table_favorite_fields") || !((_a = props.contexts) == null ? void 0 : _a.favoriteFields) || isAdding && isFieldFavorite(props) || !isAdding && !isFieldFavorite(props);
};
export default ToggleFavoriteField;
